/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Accentcontrastfontcolor3Inputs */

const en__field_accentcontrastfontcolor3 = /** @type {(inputs: _Field_Accentcontrastfontcolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`accent contrast font color`)
};

const de__field_accentcontrastfontcolor3 = /** @type {(inputs: _Field_Accentcontrastfontcolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`accent Kontrast Schriftfarbe`)
};

/**
* | output |
* | --- |
* | "accent contrast font color" |
*
* @param {_Field_Accentcontrastfontcolor3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_accentcontrastfontcolor3 = /** @type {((inputs?: _Field_Accentcontrastfontcolor3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Accentcontrastfontcolor3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_accentcontrastfontcolor3(inputs)
	return de__field_accentcontrastfontcolor3(inputs)
});
export { _field_accentcontrastfontcolor3 as "_field_accentContrastFontColor" }